import * as types from '../mutation-types'
import RegionsApi from "../../api/regions";
import axios from "axios";

// state
export const state = {
    call_center: []
};

// getters
export const getters = {
    call_center: state => state.call_center
};

// mutations
export const mutations = {
    [types.OPERATORS_CALL_CENTER_SET] (state, operators) {
        state.call_center = operators;
    }
};

// actions
export const actions = {
    async fetch(context) {
        await axios.get('/api/operators/fromMyCallCenter')
            .then(function (response) {
                context.commit(types.OPERATORS_CALL_CENTER_SET, response.data)
            });
    }
};
